import { render, staticRenderFns } from "./ListagemEntidades.vue?vue&type=template&id=39802a63"
import script from "./ListagemEntidades.vue?vue&type=script&lang=js"
export * from "./ListagemEntidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports